import ReqCompraService from "@/services/compras/ReqCompraService";

const fetch = (context, params) => {
  return ReqCompraService.fetch(params)
    .then(res => {
      context.commit('REQS_COMPRAS', res.data);
    });
};

const para_cotizar = (context, params) => {
  return ReqCompraService.para_cotizar(params)
    .then(res => {
      context.commit('REQS_COMPRAS', res.data);
    });
};

export default {
  fetch,
  para_cotizar,
};